import React from "react";
import { EXPENSE_CATEGORIES, EntryTypes } from "../utils/constants";

const CategorySelect = ({ value, onChange, entryType, translations }) => {
  if (entryType === EntryTypes.Expense) {
    return (
      <select
        className="full-width"
        onChange={(e) => onChange(e.target.value)}
        value={value}
        style={{
          direction: translations.setlang === "ar" ? "rtl" : "ltr",
          textAlign: translations.setlang === "ar" ? "right" : "left",
          width: "100%",
        }}
      >
        {EXPENSE_CATEGORIES.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>
    );
  }

  return (
    <input
      type="text"
      className="form-control"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={translations.SearchEnterycategory}
    />
  );
};

export default CategorySelect;